const ChevronRight = () => {
    return (
        <svg className="inline-block" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 18.5L15 12.5L9 6.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
  };
  
  export default ChevronRight;
  
